
import { Component, Prop, Mixins } from 'vue-property-decorator';
import interact from 'interactjs';

import DesignerElementsMixin from '../../designer-elements.mixin';

@Component({
  name: 'ed-designer-image',
})
export default class EdDesignerImageComponent extends Mixins(DesignerElementsMixin) {
  @Prop({ default: null }) readonly meta: any;

  interactModifiers = [
    interact.modifiers.aspectRatio({ ratio: 'preserve', enabled: true })
  ];

  get imageSrc() {
    return this.meta?.src;
  }

  setContainerSizes() {
    if (!this.value.sizes) {
      const img = new Image();

      img.onload = () => {
        const imgHeight = img.height;
        const imgWidth = img.width;
        const aspectRatio = imgWidth / imgHeight;
        const containerHeight = this.DesignerStateProvider.containerHeight;

        if (imgHeight >= imgWidth) {
          if (imgHeight >= this.DesignerStateProvider.containerHeight)  {
            this.setImageSizes(`${containerHeight * aspectRatio}px`, '100%');
          } else {
            this.setImageSizes(`${imgWidth}px`, `${imgHeight}px`);
          }
        } else {
          if (imgWidth >= this.DesignerStateProvider.containerWidth) {
            this.setImageSizes('100%', 'auto');
          } else {
            this.setImageSizes(`${imgWidth}px`, `${img.height}px`);
          }
        }
      };
      
      img.src = this.imageSrc;
    }
  }

  setImageSizes(width: string, height: string) {
    this.elementDesigner.style.width = width;
    this.elementDesigner.style.height = height;
  }
  

  mounted() {
    this.setContainerSizes();
    // this.onSelectElement();
  }
}
